import {kebabCase} from 'lodash';

const SPRING_PREFIX = `wf-system--`;

type CreateCSSVar = ({
  value,
  prefix,
  applyNamespace,
}: {
  value: string;
  prefix?: string;
  applyNamespace?: boolean;
}) => string;

export const createCssVar: CreateCSSVar = ({
  value,
  prefix: prefixProp,
  applyNamespace,
}) => {
  const namespace = applyNamespace ? `${SPRING_PREFIX}-` : '';
  const prefix = prefixProp ? `${prefixProp}-` : '';

  return `--${namespace}${prefix}${kebabCase(value)}`;
};
